export const useSearching = ({
  searchData,
}: {
  searchData: (isLoading: Ref<boolean>) => void
}) => {
  const noContent = ref('Aucun contenu')
  const searchMinLength = 3
  const isLoading = ref(false)
  const timeoutInstance = ref<NodeJS.Timeout>()
  const search = ref('')

  const searchUpdateHandler = async (val: string) => {
    search.value = val

    if (!search.value.length || search.value.length >= searchMinLength) {
      clearTimeout(timeoutInstance.value)
      timeoutInstance.value = setTimeout(() => searchData(isLoading), 200)
    }
  }

  return {
    noContent,
    search,
    searchMinLength,
    isLoading,
    timeoutInstance,
    searchUpdateHandler,
  }
}
